require 'angular'

angular.module('workflow.app')

.directive 'fadeOut', () ->
  return {
    link: (scope, element, attrs) ->
      scope.$$postDigest () ->
        limit = scope.$eval(attrs.fadeOut)
        if element.height() > limit
          element.addClass('fade-out')
  }
